import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import { Title } from "services/page-title/Title"

interface AppAccessPageLayoutProps {
  title: string
}

const getLayoutImageProps = (direction: "left" | "right") =>
  ({
    src: `/images/illo-login-splash-${direction}.png`,
    srcSet: `/images/illo-login-splash-${direction}-2x.png`,
    width: "16.75rem",
    height: "16.25rem"
  } as const)

// @ts-expect-error TS7006
function LayoutImage(props): JSX.Element {
  return <Box component="img" boxSizing="content-box" {...props} />
}

export function AppAccessPageLayout({
  title,
  children
}: React.PropsWithChildren<AppAccessPageLayoutProps>): JSX.Element {
  return (
    <Box
      overflow="hidden"
      display="flex"
      bgcolor={(theme) => theme.palette.info.light}
      width="100%"
      justifyContent="center"
      minHeight="100vh"
      alignItems="center"
    >
      <Title title={title} />
      <LayoutImage sx={{ marginRight: "-4rem" }} {...getLayoutImageProps("left")} alt="" />
      <Box
        zIndex="1"
        marginTop="4rem"
        sx={(theme) => ({
          minWidth: "345px",
          [theme.breakpoints.up("md")]: { maxWidth: "32rem", minWidth: "32rem" }
        })}
      >
        {children}
      </Box>
      <LayoutImage sx={{ marginLeft: "-4rem" }} {...getLayoutImageProps("right")} alt="" />
    </Box>
  )
}
